// extracted by mini-css-extract-plugin
export default {"componentWrapper":"FileAutoUploader_componentWrapper__jp6yR"};